import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";

export default function EmailTemplatePicker({
  value,          // selected templateId
  onChange        // ({ templateId, useCase, subject })
}) {

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoading(true);
    const res = await fetch(`${webUrlNode}/api/email/templates`);
    const data = await res.json();

    // only active templates are useful for canvas
    const active = data.filter(t => t.isActive === "true");

    setList(active);
    setLoading(false);
  }

  function handleSelect(e) {

    const id = Number(e.target.value);
    const t = list.find(x => x.id === id);

    if (!t) {
      onChange(null);
      return;
    }

    onChange({
      templateId: t.id,
      useCase: t.useCase,
      subject: t.subjectTemplate
    });
  }

  return (
    <div>
      <label>Email template</label>

      <select
        value={value || ""}
        onChange={handleSelect}
        style={{ width: "100%" }}
      >
        <option value="">
          {loading ? "Loading..." : "Select template"}
        </option>

        {list.map(t => (
          <option key={t.id} value={t.id}>
            {t.subjectTemplate || t.useCase}
          </option>
        ))}
      </select>

      {value && (
        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
          useCase: {list.find(x => x.id === value)?.useCase}
        </div>
      )}
    </div>
  );
}
